import Enum from "./Enum";

export default Enum.create( {
	ARCHIVED: "ARCHIVED",
	COMMENT: "COMMENT",
	CONFIDENCE: "CONFIDENCE",
	CREATE: "CREATE",
	DUE_DATE: "DUEDATE",
	FINISH_DATE: "FINISHDATE",
	START_DATE: "STARTDATE",
	TEAM: "TEAM",
	TITLE: "TITLE",
} );
